import axios from 'axios';
import API_BASE_URL from './config';

if (API_BASE_URL) {
  axios.defaults.baseURL = API_BASE_URL;
}

/** 세션 종료 처리를 두 번 실행하지 않기 위한 플래그 */
let sessionExpiredHandled = false;

export function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

/**
 * 모든 요청에 저장된 토큰을 자동으로 붙인다.
 * 컴포넌트마다 헤더를 직접 넣던 방식은 누락이 잦았고, 실제로 사용자·분류 관리 화면은
 * 헤더 없이 호출하면서 서버가 본문의 userRole 만 보고 권한을 판정하게 만든 원인이었다.
 */
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

/**
 * 토큰이 만료되거나 무효해지면 즉시 로그인 화면으로 되돌린다.
 * 예전에는 만료 후에도 로그인된 화면이 유지되면서 모든 목록이
 * "불러오지 못했습니다"로만 표시됐다.
 */
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const code = error?.response?.data?.code;

    if (status === 401 && !sessionExpiredHandled) {
      sessionExpiredHandled = true;
      clearSession();
      const message = code === 'TOKEN_EXPIRED'
        ? '로그인이 만료되었습니다. 다시 로그인해주세요.'
        : '인증이 필요합니다. 다시 로그인해주세요.';
      // 렌더링 도중 alert가 걸리지 않도록 다음 틱으로 미룬다.
      setTimeout(() => {
        window.alert(message);
        window.location.href = '/';
      }, 0);
    }

    return Promise.reject(error);
  }
);

export default axios;
